import React, { useState } from "react";
import { customerReviews } from "../Scripts/reviews";
import "../Styles/Reviews.css";
import DoctorCard from "./DoctorCard";
import postgres from "../Assets/postgreql.png";
import oracle from "../Assets/oracle.jpeg";
import mysql from "../Assets/mysql.png";
import sybase from "../Assets/sybase.png";
import mongodb from "../Assets/mongodb.jpg";
import redis from "../Assets/redis.png";
import Marquee from "react-fast-marquee";

function Databases() {
  let rMessage, rName, rLocation;
  const reviewsLength = customerReviews.length - 1;
  const [review, setReview] = useState(0);

  // back to previous review
  const backBtnClick = () => {
    setReview(review <= 0 ? reviewsLength : review - 1);
    handleReviewsUpdation();
  };

  // go to newer review
  const frontBtnClick = () => {
    setReview(review >= reviewsLength ? 0 : review + 1);
    handleReviewsUpdation();
  };

  // update reviews
  const handleReviewsUpdation = () => {
    const reviewMessage = customerReviews[review];
    rName = reviewMessage.name;
    rLocation = reviewMessage.location;
    rMessage = reviewMessage.message;
  };

  // list review on visit
  handleReviewsUpdation();

  return (
    <div className="review-section" id="databases">
      <div className="rw-text-content">
        <p className="rw-text-title">
          Almost all <span className="rw-text-num">Major Databases</span>
        </p>

        <p className="rw-text-desc">Consult us on all the following</p>

        {/*<p className="rw-text-format">*/}
        {/*  <span className="rw-text-quote1">''</span>*/}
        {/*  <span className="rw-review">{rMessage}</span>*/}
        {/*  <span className="rw-text-quote2">''</span>*/}
        {/*</p>*/}

          <Marquee
              speed={100}
              pauseOnHover={true}
          >
              <DoctorCard
                  img={postgres}
                  name="PostgreSQL"
                  title=""
                  stars="4.8"
                  reviews="700"
              />
              <DoctorCard
                  img={oracle}
                  name="Oracle"
                  title=""
                  stars="4.7"
                  reviews="450"
              />
              <DoctorCard
                  img={mysql}
                  name="MySQL"
                  title=""
                  stars="4.8"
                  reviews="500"
              />
              <DoctorCard
                  img={sybase}
                  name="Sybase"
                  title=""
                  stars="4.8"
                  reviews="500"
              />
              <DoctorCard
                  img={mongodb}
                  name="Mongo DB"
                  title=""
                  stars="4.8"
                  reviews="500"
              />
              <DoctorCard
                  img={redis}
                  name="Redis"
                  title=""
                  stars="4.8"
                  reviews="500"
              />
          </Marquee>
      </div>
    </div>
  );
}

export default Databases;
